/**
 * Remounts its subtree whenever the owner of the screen or what the owner may do changes (batch 8 T13b1 repair, #3034).
 *
 * Drafts, selected entities, open dialogs, a displayed cost preview, names and a request's state all belong to the signed-in
 * owner (tenant, user, session family, generation) and to the rights it holds. The key is read in the very render that sees the
 * change, so no frame shows another owner's drafts, costs or names, and nothing of the old subtree survives to report a late result.
 * Unresolved keyed requests are not state of the subtree: they live in the owner's journal and are found again by their own owner.
 */

import { Fragment, type ReactNode } from 'react';
import { accessKey, usePricingAccess } from './pricingSession';

export function OwnedBoundary({ children }: { children: ReactNode }) {
  const access = usePricingAccess();
  return <Fragment key={accessKey(access)}>{children}</Fragment>;
}
